import {
  DEFAULT_STATE,
  OfferRedirectLinkActions,
  isValidOfferRedirectLink,
  PersonalLoanRedirectState,
  EligibleAffiliateActions,
  BLANK_OfferRedirectLink,
  BLANK_EligibleAffiliate,
  isValidEligibleAffiliate,
  BLANK_OfferRedirectLinkWorkspaceData,
} from './Constants';
import {
  PersonalLoanRedirectScreenState,
  OfferRedirectLinkWorkspaceData,
  OfferRedirectLinkWorspaceMap,
  EligibleAffiliateWorspaceMap,
  EligibleAffiliateWorkspaceData,
  OfferRedirectHistoryMap,
  HistoryFilter,
  EligibleAffiliateHistoryMap,
} from './Types';
import {
  OfferRedirectLink,
  EligibleAffiliate,
  OfferRedirectHistory,
  EligibleAffiliateHistory,
} from '../../../types';
import moment from 'moment';
import { HistoryFilterOptions } from './Types';

export default function(state = DEFAULT_STATE, action: any): PersonalLoanRedirectScreenState {
  switch (action.type) {
    case OfferRedirectLinkActions.DATA_LOADING:
      return {
        ...state,
        loadStatus: 1,
        offerRedirectLinks: {
          ...state.offerRedirectLinks,
          state: PersonalLoanRedirectState.LOADING,
        },
      };
    //
    case OfferRedirectLinkActions.DATA_FAILED:
      return {
        ...state,
        loadStatus: 0,
        offerRedirectLinks: {
          ...state.offerRedirectLinks,
          state: PersonalLoanRedirectState.LOADING,
        },
      };
    //
    case OfferRedirectLinkActions.DATA_LOADED:
      return {
        ...state,
        loadStatus: 2,
        offerRedirectLinks: {
          ...state.offerRedirectLinks,
          state: PersonalLoanRedirectState.NORMAL,
          list: action.payload.data.map((data: OfferRedirectLink) => ({
            data,
            filtered: applyFilterToOfferRedirectLinkWorkspaceData(
              state.offerRedirectLinks.search,
              data,
            ),
          })),
          form: {
            ...state.offerRedirectLinks.form,
            enabled: false,
          },
        },
      };
    //
    case OfferRedirectLinkActions.CREATE_ENTRY:
      return {
        ...state,
        offerRedirectLinks: {
          ...state.offerRedirectLinks,
          form: {
            data: { ...BLANK_OfferRedirectLink },
            enabled: true,
            errors: [],
          },
        },
      };
    case OfferRedirectLinkActions.EDIT_ENTRY:
      return {
        ...state,
        offerRedirectLinks: {
          ...state.offerRedirectLinks,
          form: {
            data: action.payload,
            enabled: true,
            errors: [],
          },
        },
      };
    //
    case OfferRedirectLinkActions.CANCEL_ENTRY:
      return {
        ...state,
        offerRedirectLinks: {
          ...state.offerRedirectLinks,
          form: {
            ...state.offerRedirectLinks.form,
            enabled: false,
            errors: [],
          },
        },
      };
    //
    case OfferRedirectLinkActions.FAILED_SAVING_ENTRY:
      return {
        ...state,
        offerRedirectLinks: {
          ...state.offerRedirectLinks,
          form: {
            ...state.offerRedirectLinks.form,
            enabled: false,
            errors: ['Saving failed.'],
          },
        },
      };
    //
    case OfferRedirectLinkActions.SAVED_ENTRY:
      return {
        ...state,
        offerRedirectLinks: {
          ...state.offerRedirectLinks,
          form: {
            ...state.offerRedirectLinks.form,
            enabled: false,
            errors: [],
          },
        },
      };
    //
    case OfferRedirectLinkActions.SEARCH_KEYWORD_CHANGED:
      return applyFilterToOfferRedirectLinkWorkspace(action.payload, {
        ...state,
        offerRedirectLinks: {
          ...state.offerRedirectLinks,
          search: action.payload,
        },
      });
    //
    case OfferRedirectLinkActions.HISTORY_LOADED:
      return createOfferRedirectHistoryMap(state, action.payload.data);
    //
    case OfferRedirectLinkActions.HISTORY_FILTER_CHANGED:
      let filters: HistoryFilter = {
        ...state.offerRedirectLinks.historyFilter,
        [action.payload.filterKey]: action.payload.filterValue,
      };
      return applyFilterToOfferRedirectHistoryMap(filters, state);

    case EligibleAffiliateActions.DATA_LOADING:
      return {
        ...state,
        loadStatus: 1,
        affiliates: { ...state.affiliates, state: PersonalLoanRedirectState.LOADING },
      };
    //
    case EligibleAffiliateActions.DATA_FAILED:
      return {
        ...state,
        loadStatus: 0,
        affiliates: { ...state.affiliates, state: PersonalLoanRedirectState.LOADING },
      };
    //
    case EligibleAffiliateActions.DATA_LOADED:
      return {
        ...state,
        loadStatus: 2,
        affiliates: {
          ...state.affiliates,
          state: PersonalLoanRedirectState.NORMAL,
          list: action.payload.data.map((data: EligibleAffiliate) => ({
            data,
            filtered: applyFilterToEligibleAffiliateWorkspaceData(state.affiliates.search, data),
          })),
          form: {
            ...state.affiliates.form,
            enabled: false,
          },
        },
      };

    case EligibleAffiliateActions.CREATE_ENTRY:
      return {
        ...state,
        affiliates: {
          ...state.affiliates,
          form: {
            data: { ...BLANK_EligibleAffiliate },
            enabled: true,
            errors: [],
          },
        },
      };
    case EligibleAffiliateActions.EDIT_ENTRY:
      return {
        ...state,
        affiliates: {
          ...state.affiliates,
          form: {
            data: action.payload,
            enabled: true,
            errors: [],
          },
        },
      };
    //
    case EligibleAffiliateActions.CANCEL_ENTRY:
      return {
        ...state,
        affiliates: {
          ...state.affiliates,
          form: {
            ...state.affiliates.form,
            enabled: false,
            errors: [],
          },
        },
      };
    //
    case EligibleAffiliateActions.FAILED_SAVING_ENTRY:
      return {
        ...state,
        affiliates: {
          ...state.affiliates,
          form: {
            ...state.affiliates.form,
            errors: ['Saving failed.'],
          },
        },
      };
    //
    case EligibleAffiliateActions.SAVED_ENTRY:
      return {
        ...state,
        affiliates: {
          ...state.affiliates,
          form: {
            ...state.affiliates.form,
            enabled: false,
            errors: [],
          },
        },
      };
    //
    case EligibleAffiliateActions.SEARCH_KEYWORD_CHANGED:
      return applyFilterToEligibleAffiliateWorkspace(action.payload, {
        ...state,
        affiliates: {
          ...state.affiliates,
          search: action.payload,
        },
      });
    //
    case EligibleAffiliateActions.HISTORY_LOADED:
      return createEligibleAffiliateHistoryMap(state, action.payload.data);
    //
    case EligibleAffiliateActions.HISTORY_FILTER_CHANGED:
      let eligibleAffiliatefilters: HistoryFilter = {
        ...state.offerRedirectLinks.historyFilter,
        [action.payload.filterKey]: action.payload.filterValue,
      };
      return applyFilterToEligibleAffiliateHistoryMap(eligibleAffiliatefilters, state);
    //
    default:
      return state;
  }
}

const createOfferRedirectHistoryMap = (
  state: PersonalLoanRedirectScreenState,
  payload: Array<OfferRedirectHistory>,
): PersonalLoanRedirectScreenState => {
  let historyMap: OfferRedirectHistoryMap = {};
  let filterOptions: HistoryFilterOptions = {
    users: [],
    actions: [],
  };

  payload.forEach((history: OfferRedirectHistory) => {
    historyMap[history.OfferRedirectLinkHistoryId] = {
      data: history,
      filtered: isOfferRedirectHistoryFiltered(history, state.offerRedirectLinks.historyFilter),
    };

    if (!filterOptions.users.includes(history.UserId.toLowerCase())) {
      filterOptions.users.push(history.UserId.toLowerCase());
    }

    if (!filterOptions.actions.includes(history.Action)) {
      filterOptions.actions.push(history.Action);
    }
  });

  return {
    ...state,
    offerRedirectLinks: {
      ...state.offerRedirectLinks,
      state: PersonalLoanRedirectState.HISTORY,
      history: historyMap,
      historyFilterOptions: filterOptions,
    },
  };
};

const isOfferRedirectHistoryFiltered = (
  history: OfferRedirectHistory,
  filters: HistoryFilter,
): boolean => {
  let keyw_f: boolean = false;
  let user_f: boolean = false;
  let action_f: boolean = false;

  if (filters.keyword === null || filters.keyword === '') {
    keyw_f = false;
  } else {
    const keyFilterRegex = new RegExp(filters.keyword, 'i');
    keyw_f = !(
      keyFilterRegex.test(history.New) ||
      (history.Current !== null && keyFilterRegex.test(history.Current))
    );
  }

  if (filters.user_id === null || filters.user_id === '') {
    user_f = false;
  } else {
    user_f = history.UserId.toLowerCase() !== filters.user_id.toLowerCase();
  }

  if (filters.action === null || filters.action === '') {
    action_f = false;
  } else {
    action_f = history.Action.toLowerCase() !== filters.action.toLowerCase();
  }

  return keyw_f || user_f || action_f;
};

const applyFilterToOfferRedirectHistoryMap = (
  filters: HistoryFilter,
  state: PersonalLoanRedirectScreenState,
): PersonalLoanRedirectScreenState => {
  let historyMap: OfferRedirectHistoryMap = {};

  Object.keys(state.offerRedirectLinks.history).forEach((historyId: string) => {
    historyMap[historyId] = {
      ...state.offerRedirectLinks.history[historyId],
      filtered: isOfferRedirectHistoryFiltered(
        state.offerRedirectLinks.history[historyId].data,
        filters,
      ),
    };
  });

  return {
    ...state,
    offerRedirectLinks: {
      ...state.offerRedirectLinks,
      history: historyMap,
      historyFilter: filters,
    },
  };
};

const createEligibleAffiliateHistoryMap = (
  state: PersonalLoanRedirectScreenState,
  payload: Array<EligibleAffiliateHistory>,
): PersonalLoanRedirectScreenState => {
  let historyMap: EligibleAffiliateHistoryMap = {};
  let filterOptions: HistoryFilterOptions = {
    users: [],
    actions: [],
  };

  payload.forEach((history: EligibleAffiliateHistory) => {
    historyMap[history.EligibleAffiliateHistoryId] = {
      data: history,
      filtered: isEligibleAffiliateHistoryFiltered(history, state.affiliates.historyFilter),
    };

    if (!filterOptions.users.includes(history.UserId.toLowerCase())) {
      filterOptions.users.push(history.UserId.toLowerCase());
    }

    if (!filterOptions.actions.includes(history.Action)) {
      filterOptions.actions.push(history.Action);
    }
  });

  return {
    ...state,
    affiliates: {
      ...state.affiliates,
      state: PersonalLoanRedirectState.HISTORY,
      history: historyMap,
      historyFilterOptions: filterOptions,
    },
  };
};

const isEligibleAffiliateHistoryFiltered = (
  history: EligibleAffiliateHistory,
  filters: HistoryFilter,
): boolean => {
  let keyw_f: boolean = false;
  let user_f: boolean = false;
  let action_f: boolean = false;

  if (filters.keyword === null || filters.keyword === '') {
    keyw_f = false;
  } else {
    const keyFilterRegex = new RegExp(filters.keyword, 'i');
    keyw_f = !(
      keyFilterRegex.test(history.New) ||
      (history.Current !== null && keyFilterRegex.test(history.Current))
    );
  }

  if (filters.user_id === null || filters.user_id === '') {
    user_f = false;
  } else {
    user_f = history.UserId.toLowerCase() !== filters.user_id.toLowerCase();
  }

  if (filters.action === null || filters.action === '') {
    action_f = false;
  } else {
    action_f = history.Action.toLowerCase() !== filters.action.toLowerCase();
  }

  return keyw_f || user_f || action_f;
};

const applyFilterToEligibleAffiliateHistoryMap = (
  filters: HistoryFilter,
  state: PersonalLoanRedirectScreenState,
): PersonalLoanRedirectScreenState => {
  let historyMap: EligibleAffiliateHistoryMap = {};

  Object.keys(state.affiliates.history).forEach((historyId: string) => {
    historyMap[historyId] = {
      ...state.affiliates.history[historyId],
      filtered: isEligibleAffiliateHistoryFiltered(
        state.affiliates.history[historyId].data,
        filters,
      ),
    };
  });

  return {
    ...state,
    affiliates: { ...state.affiliates, history: historyMap, historyFilter: filters },
  };
};

const applyFilterToOfferRedirectLinkWorkspaceData = (
  filter: string,
  orl: OfferRedirectLink,
): boolean => {
  if (filter !== null && filter !== '') {
    const filterRegex = new RegExp(filter, 'i');
    return !(
      filterRegex.test(orl.OfferId.toString()) ||
      filterRegex.test(orl.CreditRatingBucket) ||
      filterRegex.test(orl.RedirectUrl)
    );
  } else {
    return false;
  }
};

const applyFilterToOfferRedirectLinkWorkspace = (
  filter: string,
  state: PersonalLoanRedirectScreenState,
): PersonalLoanRedirectScreenState => {
  let workSpace: OfferRedirectLinkWorspaceMap = {};

  Object.values(state.offerRedirectLinks.list).forEach(
    (workdata: OfferRedirectLinkWorkspaceData) => {
      workSpace[workdata.data.OfferRedirectLinkId] = {
        ...workdata,
        filtered: applyFilterToOfferRedirectLinkWorkspaceData(filter, workdata.data),
      };
    },
  );

  return {
    ...state,
    offerRedirectLinks: { ...state.offerRedirectLinks, list: workSpace, keyword: filter },
  };
};

const processOfferRedirectLink = (
  state: PersonalLoanRedirectScreenState,
  payload: OfferRedirectLink,
): PersonalLoanRedirectScreenState => {
  if (isValidOfferRedirectLink(payload)) {
    let duplicated: boolean = false;
    Object.values(state.offerRedirectLinks.list).forEach(
      (workdata: OfferRedirectLinkWorkspaceData) => {
        const { data } = workdata;

        duplicated =
          duplicated ||
          (data.OfferRedirectLinkId !== payload.OfferRedirectLinkId &&
            data.OfferId * 1 === payload.OfferId * 1 &&
            data.CreditRatingBucket === payload.CreditRatingBucket);
      },
    );

    if (duplicated) {
      return {
        ...state,
        offerRedirectLinks: {
          ...state.offerRedirectLinks,
          form: {
            ...state.offerRedirectLinks.form,
            errors: ['Same Offer ID, Credit Rating Bucket combination exists elsewhere.'],
          },
        },
      };
    }
  } else {
    return {
      ...state,
      offerRedirectLinks: {
        ...state.offerRedirectLinks,
        form: {
          ...state.offerRedirectLinks.form,
          errors: ['Invalid field entry.'],
        },
      },
    };
  }

  return {
    ...state,
    offerRedirectLinks: {
      ...state.offerRedirectLinks,
      form: {
        ...state.offerRedirectLinks.form,
        errors: [],
      },
    },
  };
};

const applyFilterToEligibleAffiliateWorkspaceData = (
  filter: string,
  orl: EligibleAffiliate,
): boolean => {
  if (filter !== null && filter !== '') {
    const filterRegex = new RegExp(filter, 'i');
    return !filterRegex.test(orl.AffiliateId.toString());
  } else {
    return false;
  }
};

const applyFilterToEligibleAffiliateWorkspace = (
  filter: string,
  state: PersonalLoanRedirectScreenState,
): PersonalLoanRedirectScreenState => {
  let workSpace: EligibleAffiliateWorspaceMap = {};

  Object.values(state.affiliates.list).forEach((workdata: EligibleAffiliateWorkspaceData) => {
    workSpace[workdata.data.EligibleAffiliateId] = {
      ...workdata,
      filtered: applyFilterToEligibleAffiliateWorkspaceData(filter, workdata.data),
    };
  });

  return { ...state, affiliates: { ...state.affiliates, list: workSpace, keyword: filter } };
};

const processEligibleAffiliate = (
  state: PersonalLoanRedirectScreenState,
  payload: EligibleAffiliate,
): PersonalLoanRedirectScreenState => {
  if (isValidEligibleAffiliate(payload)) {
    let duplicated: boolean = false;
    Object.values(state.affiliates.list).forEach((workdata: EligibleAffiliateWorkspaceData) => {
      const { data } = workdata;

      duplicated =
        duplicated ||
        (data.EligibleAffiliateId !== payload.EligibleAffiliateId &&
          data.AffiliateId * 1 === payload.AffiliateId * 1);
    });

    if (duplicated) {
      return {
        ...state,
        affiliates: {
          ...state.affiliates,
          form: {
            ...state.affiliates.form,
            errors: ['Same Affiliate ID exists elsewhere.'],
          },
        },
      };
    }
  } else {
    return {
      ...state,
      affiliates: {
        ...state.affiliates,
        form: {
          ...state.affiliates.form,
          errors: ['Invalid field entry.'],
        },
      },
    };
  }

  return {
    ...state,
    affiliates: {
      ...state.affiliates,
      form: {
        ...state.affiliates.form,
        errors: [],
      },
    },
  };
};
